export default process.env.REACT_APP_LOGO_IMAGE_URL_PREFIX || "https://cdn.flightlocal.com/airline-logo/"